import React from 'react';
import ProductCategoryController from '../../controllers/ProductCategoryController';
import {
	Container,
	Typography,
	Grid,
	Table,
	TableHead,
	TableRow,
	TableCell,
	Button,
	TableBody,
	Dialog,
	DialogTitle,
	Divider,
	DialogContent,
	TextField,
	DialogActions,
} from '@material-ui/core';
import { LoadingOverlay } from '../../components/Common/LoadingOverlay';
import { Alert } from '@material-ui/lab';
import { AddCircle, Delete, Edit } from '@material-ui/icons';
import { isNullOrUndefined } from '../../helpers/Utils';

export default function ProductCategoryEditor() {
	const [loading, setLoading] = React.useState(true);
	const [warningText, setWarningText] = React.useState(null);
	const [ProductCategorys, setProductCategorys] = React.useState([]);

	const [showAddModal, setShowAddModal] = React.useState(false);
	const [newProductCategoryName, setNewProductCategoryName] = React.useState('');
	const [newProductCategoryIndex, setNewProductCategoryIndex] = React.useState(0);
	const [adding, SetAdding] = React.useState(false);

	const [showDelete, setShowDelete] = React.useState(false);
	const [showEdit, setShowEdit] = React.useState(false);
	const [editValue, setEditValue] = React.useState(null);
	// initialise
	React.useEffect(() => {
		async function init() {
			const response = await ProductCategoryController.getProductCategories();
			if (response.hasError) {
				HandleError(response.data.response);
			} else {
				setProductCategorys(response.data);
			}
			setLoading(false);
		}
		init();
	}, [setProductCategorys]);

	function handleInput(event) {
		const name = event.target.name;
		const value = event.target.value;

		switch (name) {
			case 'ProductCategoryName':
				setNewProductCategoryName(value);
				break;
			case 'ProductCategoryIndex':
				setNewProductCategoryIndex(value);
				break;
			default:
				return;
		}
	}

	async function AddProductCategory() {
		SetAdding(true);
		const response = await ProductCategoryController.addProductCategory(
			newProductCategoryName,
			newProductCategoryIndex
		);
		if (response.hasError) {
			SetAdding(false);
			HandleError(response.data.response);
			return;
		}
		SetAdding(false);
		setProductCategorys([...ProductCategorys, response.data]);
		setShowAddModal(false);
		setNewProductCategoryName('');
		setNewProductCategoryIndex(0);
		setWarningText(null);
	}

	async function SaveProductCategory() {
		SetAdding(true);
		const response = await ProductCategoryController.editProductCategory(
			editValue.id,
			newProductCategoryName,
			newProductCategoryIndex
		);
		if (response.hasError) {
			SetAdding(false);
			HandleError(response.data.response);
			return;
		}
		SetAdding(false);
		editValue.name = newProductCategoryName;
		editValue.orderIndex = newProductCategoryIndex;
		setShowEdit(false);
		setNewProductCategoryName('');
		setNewProductCategoryIndex(0);
		setWarningText(null);
	}

	async function ConfirmDeleteProductCategory() {
		SetAdding(true);
		const response = await ProductCategoryController.deleteProductCategory(editValue.id);
		if (response.hasError) {
			SetAdding(false);
			HandleError(response.data.response);
			return;
		}
		SetAdding(false);
		const currentProductCategorys = ProductCategorys;
		currentProductCategorys.splice(currentProductCategorys.indexOf(editValue), 1);
		setProductCategorys([...currentProductCategorys]);
		setShowDelete(false);
		setWarningText(null);
	}

	function HandleError(response) {
		if (isNullOrUndefined(response)) {
			return 'Failed to connect to server. Please check your internet connection';
		}
		if (isNullOrUndefined(response.response) || isNullOrUndefined(response.response.data)) {
			setWarningText(response.message);
			return;
		}
		setWarningText(response.response.data);
	}

	function EditProductCategory(value) {
		setShowEdit(true);
		setEditValue(value);
		setNewProductCategoryName(value.name);
		setNewProductCategoryIndex(value.orderIndex);
	}

	function CloseEdit() {
		setShowEdit(false);
		setEditValue(null);
		setNewProductCategoryName('');
		setNewProductCategoryIndex(0);
		setWarningText(null);
	}

	function DeleteProductCategory(value) {
		setShowDelete(true);
		setEditValue(value);
		setNewProductCategoryName(value.name);
	}

	function CloseDelete() {
		setShowDelete(false);
		setEditValue(null);
		setWarningText(null);
	}

	function buildTable() {
		return (
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Name</TableCell>
						<TableCell>Order Index</TableCell>
						<TableCell></TableCell>
						<TableCell align="right">
							<Button
								onClick={() => {
									setShowAddModal(true);
								}}
							>
								<AddCircle />
							</Button>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{ProductCategorys.sort((a, b) => {
						return a.orderIndex < b.orderIndex ? -1 : 1;
					}).map(value => {
						return (
							<TableRow key={value.id}>
								<TableCell>{value.name}</TableCell>
								<TableCell>{value.orderIndex}</TableCell>
								<TableCell align="right">
									<Button
										onClick={() => {
											EditProductCategory(value);
										}}
									>
										<Edit />
									</Button>
								</TableCell>
								<TableCell align="right">
									<Button
										onClick={() => {
											DeleteProductCategory(value);
										}}
									>
										<Delete />
									</Button>
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		);
	}

	function buildAddModal() {
		return (
			<Dialog
				open={showAddModal}
				onClose={() => {
					setShowAddModal(false);
				}}
			>
				<DialogTitle>Add ProductCategory</DialogTitle>
				<Divider />
				<DialogContent>
					<TextField
						id="ProductCategory-Name"
						label="ProductCategory Name *"
						value={newProductCategoryName}
						onChange={handleInput}
						variant="outlined"
						name="ProductCategoryName"
					/>
					<TextField
						id="ProductCategory-Index"
						label="ProductCategory Index *"
						value={newProductCategoryIndex}
						onChange={handleInput}
						variant="outlined"
						name="ProductCategoryIndex"
					/>
					{buildWarning()}
				</DialogContent>
				<Divider />
				<DialogActions>
					<Button onClick={() => AddProductCategory()} disabled={adding}>
						{adding ? 'Adding' : 'Add'}
					</Button>
					<Button
						onClick={() => {
							setShowAddModal(false);
						}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	function buildEditModal() {
		return (
			<Dialog
				open={showEdit}
				onClose={() => {
					CloseEdit();
				}}
			>
				<DialogTitle>Edit ProductCategory</DialogTitle>
				<Divider />
				<DialogContent>
					<TextField
						id="ProductCategory-Name"
						label="ProductCategory Name *"
						value={newProductCategoryName}
						onChange={handleInput}
						variant="outlined"
						name="ProductCategoryName"
					/>
					<TextField
						id="ProductCategory-Index"
						label="ProductCategory Index *"
						value={newProductCategoryIndex}
						onChange={handleInput}
						variant="outlined"
						name="ProductCategoryIndex"
					/>
					{buildWarning()}
				</DialogContent>
				<Divider />
				<DialogActions>
					<Button onClick={() => SaveProductCategory()} disabled={adding}>
						{adding ? 'Saving' : 'Save'}
					</Button>
					<Button
						onClick={() => {
							CloseEdit();
						}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	function buildDeleteModal() {
		return (
			<Dialog
				open={showDelete}
				onClose={() => {
					CloseDelete();
				}}
			>
				<DialogTitle>Delete ProductCategory</DialogTitle>
				<Divider />
				<DialogContent>
					<p>You are permanently deleting {editValue?.name}</p>
					{buildWarning()}
				</DialogContent>
				<Divider />
				<DialogActions>
					<Button onClick={() => ConfirmDeleteProductCategory()} disabled={adding}>
						{adding ? 'Deleting' : 'Delete'}
					</Button>
					<Button
						onClick={() => {
							CloseDelete();
						}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	function buildWarning() {
		if (isNullOrUndefined(warningText)) return null;
		return <Alert severity="warning">{warningText}</Alert>;
	}

	return (
		<Container maxWidth="xs">
			<LoadingOverlay loading={loading} />

			<Typography variant="h3" align="center" gutterBottom>
				ProductCategory Editing
			</Typography>
			{buildAddModal()}
			{buildEditModal()}
			{buildDeleteModal()}
			<Grid item xs={12}>
				{buildWarning()}
			</Grid>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					{buildTable()}
				</Grid>
			</Grid>
		</Container>
	);
}

ProductCategoryEditor.propTypes = {};
